/**
 * 結果モーダル（クリア/失敗）
 *
 * 画面中央にオーバーレイ表示。閉じるボタンまたはオーバーレイクリックで閉じる。
 */
export class ResultModal {
  private overlay: HTMLElement;
  private messageEl: HTMLElement;

  constructor() {
    this.overlay = document.createElement("div");
    this.overlay.className = "result-modal";
    this.overlay.setAttribute("role", "dialog");
    this.overlay.setAttribute("aria-modal", "true");
    this.overlay.style.display = "none";

    const box = document.createElement("div");
    box.className = "result-modal__box";

    this.messageEl = document.createElement("div");
    this.messageEl.className = "result-modal__message";
    box.appendChild(this.messageEl);

    const closeBtn = document.createElement("button");
    closeBtn.className = "result-modal__close";
    closeBtn.textContent = "閉じる";
    closeBtn.addEventListener("click", () => this.close());
    box.appendChild(closeBtn);

    this.overlay.appendChild(box);

    // オーバーレイクリックで閉じる
    this.overlay.addEventListener("click", (e) => {
      if (e.target === this.overlay) this.close();
    });

    // ESCで閉じる
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.overlay.style.display !== "none") {
        this.close();
      }
    });

    document.body.appendChild(this.overlay);
  }

  show(message: string, type: "success" | "failure"): void {
    this.messageEl.textContent = message;
    this.overlay.classList.remove(
      "result-modal--success",
      "result-modal--failure"
    );
    this.overlay.classList.add(`result-modal--${type}`);
    this.overlay.style.display = "";
  }

  close(): void {
    this.overlay.style.display = "none";
  }
}
